import styled from 'styled-components';

export const Container = styled.div`
    position: fixed;
    display: ${({ isOpen }) => isOpen ? 'flex' : 'none'};
    top:0px;
    left: 0px;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    cursor: default;
    animation: ModalShow .1s ease-out;
    user-select: none;
    background-color: #00000040;
    @keyframes ModalShow{
        0% {
            opacity: 0;
            transform: scale(1.2);
        }
        100% {
            opacity: 0;
            transform: scale(1);
        }
    }
    > div {
        display: flex;
        width: 450px;
        height: 500px;
        padding: 1rem;
        border-radius: 6px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #ffffff;
        gap: 1rem;
        .listUsers-filter{
            max-height: 2.2rem;
        }
        .title {
            display: flex;
            justify-content: flex-start;
            align-items: end;
            font-size: 1.1rem;
            font-weight: bold;
            margin-top: 0.5rem;
        }
        > ul {
            display: flex;
            width: 100%;
            height: 100%;
            flex-direction: column;
            gap: .3rem;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                width: 5px;
                height: 5px;
            }
            &::-webkit-scrollbar-thumb{
                background-color: rgb(0, 0, 0,0.2);
            }
            > li {
                display: flex;
                width: 100%;
                min-height: 4rem;
                align-items: center;
                gap: .5rem;
                padding: .3rem;
                border-radius: 4px;
                background-color: #f6f6f6;
                cursor: pointer;
                > span {
                    font-size: 1rem;
                    font-weight: 500;
                    color: black;
                }
                &:hover{
                    opacity: .5;
                }
            }
        }
        > button {
            display: flex;
            min-height: 35px;
            width: 150px;
            justify-content: center;
            align-items: center;
            gap:1rem;
            outline: none;
            border:none; 
            border-radius: 4px;
            font-size: 14px;
            text-align: center;
            font-weight: bolder;
            background-color: #d93e3e;
            color: #ffffff;
            cursor: pointer;
            &:hover{
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
            }
        }
        .loader {
            width: 50px;
            aspect-ratio: 1;
            display: grid;
            border: 4px solid #0000;
            border-radius: 50%;
            border-right-color: #25b09b;
            animation: l15 1s infinite linear;
        }
        .loader::before,
        .loader::after {    
            content: "";
            grid-area: 1/1;
            margin: 2px;
            border: inherit;
            border-radius: 50%;
            animation: l15 2s infinite;
        }
        .loader::after {
            margin: 8px;
            animation-duration: 3s;
        }
        @keyframes l15{ 
            100%{transform: rotate(1turn)}
        }
    }
`;